import { HighlightFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import Content from '../../components/Content';
import { mapHighlightContent } from '../../components/Content/helpers';
import { Heading3 } from '../../components/Text';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './highlight.module.css';

const Highlight: ContentBlock<HighlightFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.highlight;

  if (!contentBlockProps) {
    return null;
  }

  const isImageOnLeft = contentBlockProps.imagePlacement?.toLowerCase() === 'left';

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.highlightContainer}
    >
      {contentBlockProps.image && (
        <AppImage
          className={isImageOnLeft ? style.highlightImageLeft : style.highlightImageRight}
          fallbackHeight={367}
          fallbackWidth={550}
          image={contentBlockProps.image}
        />
      )}

      <div className={isImageOnLeft ? style.highlightTextContainerRight : style.highlightTextContainerLeft}>
        <SectionTitle className={style.highlightTitle}>
          {contentBlockProps.title}
        </SectionTitle>

        {contentBlockProps.subtitle && (
          <Heading3
            className={style.highlightSubtitle}
            fontSizeOverride={24}
          >
            {contentBlockProps.subtitle}
          </Heading3>
        )}

        {contentBlockProps.content && (
          <Content content={mapHighlightContent(contentBlockProps.content)} />
        )}
      </div>
    </Section>
  );
};

export default Highlight;
